/* Copyright (C) 2018 HTC Global Services, Inc. - All Rights Reserved  */
import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'keys',  pure: false })
export class KeysPipe implements PipeTransform {
    transform(value: any, args: any[] = null): any {
        return Object.keys(value);
    }
}
